import React, { useState } from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import EnergyForm from './components/energy-form';
import EnergyTable from './components/energy-table';
import EnergyGraph from './components/energy-graph';

const App = () => (
  <div>
    <Navbar bg="light" expand="lg">
      <Navbar.Brand href="#home">W3HTech - Energy Usage Calculator</Navbar.Brand>
    </Navbar>
    <br></br>
    <Container>
      <Row>
        <Col>
          <EnergyForm />
        </Col>
        <Col>
          <EnergyTable />
        </Col>
      </Row>
      <Row>
        <Col><EnergyGraph/></Col>
      </Row>
      <Row>
        <Col>
          <h4>Energy usage calculation forumla :- </h4>
          <ul>
            <li>(Wattage × Hours Used Per Day) ÷ 1000 = Daily Kilowatt-hour (kWh) consumption</li>
            <li>Daily kWh consumption × number of days used per year = annual energy consumption</li>
            <li>Annual energy consumption × utility rate per kWh = annual cost to run appliance </li>
          </ul>
        </Col>
      </Row>
    </Container>
  </div>
);

export default App;
